// extracted by mini-css-extract-plugin
export default {"pageSections":"c1rIl3"};